import validate from "/usr/src/app/content/n3-treatments-02df28e1-651c-42de-94be-b780dccf2327/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-02df28e1-651c-42de-94be-b780dccf2327/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}